// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import ReactMarkdown from "react-markdown";
// import { Share2, Facebook, Twitter, Mail, MessageCircle } from "lucide-react";
// import StoryCard from "../components/StoryCard";
// export default function BlogFullLeft({ blog, markdown }) {
// 	const [shareDropdown, setShareDropdown] = useState(false);
// 	const [readingTime, setReadingTime] = useState(0);

// 	useEffect(() => {
// 		// Calculate reading time (average 200 words per minute)
// 		const wordCount = markdown.split(/\s+/).length;
// 		const time = Math.ceil(wordCount / 200);
// 		setReadingTime(time);
// 	}, [markdown]);

// 	const handleShare = (platform) => {
// 		const url = window.location.href;
// 		const title = blog.title;

// 		switch (platform) {
// 			case "facebook":
// 				window.open(
// 					`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
// 						url
// 					)}`
// 				);
// 				break;
// 			case "twitter":
// 				window.open(
// 					`https://twitter.com/intent/tweet?url=${encodeURIComponent(
// 						url
// 					)}&text=${encodeURIComponent(title)}`
// 				);
// 				break;
// 			case "whatsapp":
// 				window.open(
// 					`https://api.whatsapp.com/send?text=${encodeURIComponent(
// 						title + " " + url
// 					)}`
// 				);
// 				break;
// 			case "email":
// 				window.location.href = `mailto:?subject=${encodeURIComponent(
// 					title
// 				)}&body=${encodeURIComponent(url)}`;
// 				break;
// 			default:
// 				navigator.clipboard.writeText(url);
// 				alert("Link copied to clipboard!");
// 		}
// 		setShareDropdown(false);
// 	};

// 	return (
// 		<div className='blog-left-side'>
// 			{/* Back Navigation */}
// 			<div className='back-navigation'>
// 				<Link to='/blogs' className='back-link'>
// 					← Back to Blogs
// 				</Link>
// 			</div>

// 			{/* Blog Header */}
// 			<div className='blog-header'>
// 				<div className='blog-meta'>
// 					<span className='blog-category'>{blog.category || "Health"}</span>
// 					<span className='blog-date'>
// 						{blog.date || new Date().toLocaleDateString()}
// 					</span>
// 					<span className='reading-time'>{readingTime} min read</span>
// 				</div>

// 				<h1 className='blog-title'>{blog.title}</h1>

// 				{blog.excerpt && <p className='blog-excerpt'>{blog.excerpt}</p>}

// 				{/* Social Share */}
// 				<div className='social-share'>
// 					<div className='share-container'>
// 						<button
// 							className='share-button'
// 							onClick={() => setShareDropdown(!shareDropdown)}>
// 							<Share2 size={18} />
// 							Share
// 						</button>

// 						{shareDropdown && (
// 							<div className='share-dropdown'>
// 								<button
// 									onClick={() => handleShare("facebook")}
// 									className='share-option facebook'>
// 									<Facebook size={16} />
// 									Facebook
// 								</button>
// 								<button
// 									onClick={() => handleShare("twitter")}
// 									className='share-option twitter'>
// 									<Twitter size={16} />
// 									Twitter
// 								</button>
// 								<button
// 									onClick={() => handleShare("whatsapp")}
// 									className='share-option whatsapp'>
// 									<MessageCircle size={16} />
// 									WhatsApp
// 								</button>
// 								<button
// 									onClick={() => handleShare("email")}
// 									className='share-option email'>
// 									<Mail size={16} />
// 									Email
// 								</button>
// 							</div>
// 						)}
// 					</div>
// 				</div>
// 			</div>

// 			{/* Featured Image */}
// 			{blog.imageUrl && (
// 				<div className='blog-featured-image'>
// 					<img src={blog.imageUrl} alt={blog.title} loading='lazy' />
// 				</div>
// 			)}

// 			{/* Blog Content */}
// 			<div className='blog-content'>
// 				<ReactMarkdown
// 					components={{
// 						h1: ({ children }) => <h1 className='content-h1'>{children}</h1>,
// 						h2: ({ children }) => <h2 className='content-h2'>{children}</h2>,
// 						h3: ({ children }) => <h3 className='content-h3'>{children}</h3>,
// 						p: ({ children }) => <p className='content-p'>{children}</p>,
// 						ul: ({ children }) => <ul className='content-ul'>{children}</ul>,
// 						ol: ({ children }) => <ol className='content-ol'>{children}</ol>,
// 						li: ({ children }) => <li className='content-li'>{children}</li>,
// 						blockquote: ({ children }) => (
// 							<blockquote className='content-blockquote'>{children}</blockquote>
// 						),
// 						code: ({ children }) => (
// 							<code className='content-code'>{children}</code>
// 						),
// 						pre: ({ children }) => (
// 							<pre className='content-pre'>{children}</pre>
// 						),
// 						img: ({ src, alt }) => (
// 							<div className='content-image-wrapper'>
// 								<img
// 									src={src}
// 									alt={alt}
// 									className='content-image'
// 									loading='lazy'
// 								/>
// 							</div>
// 						),
// 					}}>
// 					{markdown}
// 				</ReactMarkdown>
// 			</div>

// 			{/* Author Info */}
// 			{/* <div className='author-info'>
// 				<div className='author-avatar'>
// 					<img
// 						src={
// 							blog.authorImage ||
// 							"https://thumbs.dreamstime.com/b/happy-healthcare-portrait-doctor-hospital-proud-empowered-confident-face-leader-male-health-expert-happy-270112047.jpg"
// 						}
// 						alt={blog.author || "Author"}
// 					/>
// 				</div>
// 				<div className='author-details'>
// 					<h4>{blog.author || "Health Expert"}</h4>
// 					<p>
// 						{blog.authorBio ||
// 							"Expert in health and wellness with years of experience in medical research."}
// 					</p>
// 				</div>
// 			</div> */}

// 			{/* Related Articles */}
// 			<div className='related-articles'>
// 				<h3>Related Articles</h3>
// 				<div className='related-grid'>
// 					{/* This would be populated with related articles */}
// 					<div className='related-item'>
// 						<img
// 							src='https://floridasleepdoctors.com/wp-content/uploads/2022/07/Allergy-symptoms-scaled.jpg'
// 							alt='Related article'
// 						/>
// 						<h4>Understanding Seasonal Allergies</h4>
// 						<p>
// 							Learn more about managing allergies during different seasons...
// 						</p>
// 					</div>
// 					<div className='related-item'>
// 						<img
// 							src='https://internationalintegrative.com/wp-content/uploads/2019/10/Lesser-Known-Natural-Remedies.jpg'
// 							alt='Related article'
// 						/>
// 						<h4>Natural Remedies for Summer Health</h4>
// 						<p>Discover natural ways to stay healthy during summer...</p>
// 					</div>
// 				</div>
// 			</div>

// 			{/* Comments Section */}
// 			<div className='comments-section'>
// 				<h3>Comments</h3>
// 				<div className='comment-form'>
// 					<textarea placeholder='Share your thoughts...' rows='4'></textarea>
// 					<button className='submit-comment'>Post Comment</button>
// 				</div>
// 			</div>

// 			{/* next stories */}
// 			<div className='max-w-4xl mx-auto px-4 py-8'>
// 				<h2 className='text-3xl font-bold mb-6'>
// 					Other stories<span className='text-sky-500'>.</span>
// 				</h2>

// 				<StoryCard
// 					image='https://tse1.mm.bing.net/th?id=OIP.Qvq-QfjKYLOp9zgvcUZonQHaEK&pid=Api&P=0&h=220'
// 					title='Blood Cancer Types, What Are Its Causes, Symptoms And Know About All Stages'
// 					buttonText='Next Story'
// 					buttonPosition='right'
// 					onClick={() => alert("Next Story Clicked!")}
// 				/>

// 				<StoryCard
// 					image='https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=800&q=80'
// 					title='Millet Health Benefits, Types, Nutrition Facts And Recipes'
// 					buttonText='Previous Story'
// 					buttonPosition='left'
// 					onClick={() => alert("Previous Story Clicked!")}
// 				/>
// 			</div>
// 		</div>
// 	);
// }
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from 'remark-gfm';
import { Share2, Facebook, Twitter, Mail, MessageCircle } from "lucide-react";
import { useAuthContext } from "../context/AuthContext";
import { FiMessageCircle } from "react-icons/fi";
import { FaRegEye, FaRegHeart } from "react-icons/fa";

import StoryCard from "../components/StoryCard";

export default function BlogFullLeft({ blog, markdown, user }) {
	const { setIsAuth } = useAuthContext();
	const [shareDropdown, setShareDropdown] = useState(false);
	const [readingTime, setReadingTime] = useState(0);
	const [showLoginModal, setShowLoginModal] = useState(false);
	const [comment, setComment] = useState("");
	const [blogs, setBlogs] = useState([]);
	const [likes, setLikes] = useState(blog.stats.likes || 0);
	const [liked, setLiked] = useState(false);
	const navigate = useNavigate();

	// Fetch blogs from blogs.json
	useEffect(() => {
		fetch("/blogs.json")
			.then((res) => res.json())
			.then((data) => {
				setBlogs(data);
			})
			.catch((error) => {
				console.error("Error fetching blogs:", error);
			});
	}, []);

	useEffect(() => {
		const wordCount = markdown.split(/\s+/).length;
		const time = Math.ceil(wordCount / 200);
		setReadingTime(time);
	}, [markdown]);

	const handleShare = (platform) => {
		const url = window.location.href;
		const title = blog.title;
		switch (platform) {
			case "facebook":
				window.open(
					`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
						url
					)}`
				);
				break;
			case "twitter":
				window.open(
					`https://twitter.com/intent/tweet?url=${encodeURIComponent(
						url
					)}&text=${encodeURIComponent(title)}`
				);
				break;
			case "whatsapp":
				window.open(
					`https://api.whatsapp.com/send?text=${encodeURIComponent(
						title + " " + url
					)}`
				);
				break;
			case "email":
				window.location.href = `mailto:?subject=${encodeURIComponent(
					title
				)}&body=${encodeURIComponent(url)}`;
				break;
			default:
				navigator.clipboard.writeText(url);
				alert("Link copied to clipboard!");
		}
		setShareDropdown(false);
	};

	// Exclude current blog for "Other Stories"
	const otherStories = blogs.filter((b) => b.slug !== blog.slug).slice(0, 3);

	// Related: share at least one tag or category, but not the current blog
	const relatedArticles = blogs
		.filter(
			(b) =>
				b.slug !== blog.slug &&
				(b.tags?.some((tag) => blog.tags?.includes(tag)) ||
					(b.category && b.category === blog.category))
		)
		.slice(0, 3);

	const handleCommentSubmit = () => {
		if (!user) {
			setShowLoginModal(true);
			return;
		}
		// Place your comment submission logic here
		alert("Comment posted!");
		setComment("");
	};
	const handleLike = () => {
		if (!liked) {
			setLikes(likes + 1);
			setLiked(true);
		}
	};

	return (
		<div className='blog-left-side'>
			{/* Back Navigation */}
			<div className='back-navigation'>
				<Link to='/blogs' className='back-link'>
					← Back to Blogs
				</Link>
			</div>

			{/* Blog Header */}
			<div className='blog-header'>
				<div className='blog-meta'>
					<span className='blog-category'>{blog.category || "Health"}</span>
					<span className='blog-date'>
						{blog.date || new Date().toLocaleDateString()}
					</span>
					<span className='reading-time'>{readingTime} min read</span>
				</div>
				<h1 className='blog-title'>{blog.title}</h1>
				{blog.excerpt && <p className='blog-excerpt'>{blog.excerpt}</p>}

				{/* Social Share */}
				<div className='social-share'>
					<div className='share-container'>
						<button
							className='btn-primary'
							onClick={() => setShareDropdown(!shareDropdown)}>
							<Share2 size={18} className='mr-3' />
							Share
						</button>
						{shareDropdown && (
							<div className='share-dropdown'>
								<button
									onClick={() => handleShare("facebook")}
									className='share-option facebook'>
									<Facebook size={16} /> Facebook
								</button>
								<button
									onClick={() => handleShare("twitter")}
									className='share-option twitter'>
									<Twitter size={16} /> Twitter
								</button>
								<button
									onClick={() => handleShare("whatsapp")}
									className='share-option whatsapp'>
									<MessageCircle size={16} /> WhatsApp
								</button>
								<button
									onClick={() => handleShare("email")}
									className='share-option email'>
									<Mail size={16} /> Email
								</button>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* Featured Image */}

			{/* Featured Image with StatsBar */}
			{blog.imageUrl && (
				<div className='blog-featured-image' style={{ position: "relative" }}>
					{/* StatsBar Overlay */}
					<div
						className='stats-bar-overlay'
						style={{
							position: "absolute",
							top: 16,
							right: 16,
							display: "flex",
							gap: "18px",
							background: "rgba(8, 51, 169, 0.93)",
							borderRadius: "8px",
							padding: "6px 14px",
							boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
							alignItems: "center",
							zIndex: 2,
							color: "#fff",
						}}>
						<span
							style={{
								display: "flex",
								alignItems: "center",
								gap: 4,
								cursor: "pointer",
							}}
							onClick={handleCommentSubmit}
							title='Post a comment'>
							<FiMessageCircle style={{ fontSize: 18 }} />
							{blog.stats.comments}
						</span>
						<span style={{ display: "flex", alignItems: "center", gap: 4 }}>
							<FaRegEye style={{ fontSize: 18 }} />
							{blog.stats.views}
						</span>
						<span
							style={{
								display: "flex",
								alignItems: "center",
								gap: 4,
								cursor: "pointer",
								color: liked ? "red" : "#fff",
							}}
							onClick={handleLike}
							title={liked ? "Liked" : "Like"}>
							<FaRegHeart style={{ fontSize: 18 }} />
							{likes}
						</span>
					</div>
					<img
						src={blog.imageUrl}
						alt={blog.title}
						loading='lazy'
						style={{ width: "100%", borderRadius: 8 }}
					/>
				</div>
			)}

			{/* Blog Content */}
			<div className='blog-content'>
					<ReactMarkdown
					remarkPlugins={[remarkGfm]}
					components={{
						h1: ({ children }) => <h1 className='content-h1'>{children}</h1>,
						h2: ({ children }) => <h2 className='content-h2'>{children}</h2>,
						h3: ({ children }) => <h3 className='content-h3'>{children}</h3>,
						p: ({ children }) => <p className='content-p'>{children}</p>,
						ul: ({ children }) => <ul className='content-ul'>{children}</ul>,
						ol: ({ children }) => <ol className='content-ol'>{children}</ol>,
						li: ({ children }) => <li className='content-li'>{children}</li>,
						blockquote: ({ children }) => (
							<blockquote className='content-blockquote'>{children}</blockquote>
						),
						code: ({ children }) => (
							<code className='content-code'>{children}</code>
						),
						pre: ({ children }) => (
							<pre className='content-pre'>{children}</pre>
						),
						img: ({ src, alt }) => (
							<div className='content-image-wrapper'>
								<img
									src={src}
									alt={alt}
									className='content-image'
									loading='lazy'
								/>
							</div>
						),
						   table: ({ children }) => (
							<table
							style={{
								width: '100%',
								borderCollapse: 'collapse',
								margin: '1rem 0',
							}}
							>
							{children}
							</table>
						),
						thead: ({ children }) => <thead>{children}</thead>,
						tbody: ({ children }) => <tbody>{children}</tbody>,
						tr: ({ children }) => <tr>{children}</tr>,
						th: ({ children }) => (
							<th
							style={{
								border: '1px solid #ccc',
								padding: '8px',
								backgroundColor: '#f5f5f5',
								fontWeight: 'bold',
								textAlign: 'left',
							}}
							>
							{children}
							</th>
						),
						td: ({ children }) => (
							<td
							style={{
								border: '1px solid #ccc',
								padding: '8px',
								textAlign: 'left',
							}}
							>
							{children}
							</td>
						),
						
				}}>
				{markdown}
			</ReactMarkdown>
			</div>

			{/* Related Articles */}
			{/* {relatedArticles.length > 0 && (
				<div className='related-articles'>
					<h3>Related Articles</h3>
					<div className='related-grid'>
						{relatedArticles.slice(0, 2).map((item) => (
							<div
								className='related-item'
								key={item.slug}
								onClick={() => navigate(`/blog/${item.slug}`)}
								style={{ cursor: "pointer" }}>
								<img src={item.imageUrl} alt={item.title} loading='lazy' />
								<h4>{item.title}</h4>
								<p>{item.description}</p>
							</div>
						))}
					</div>
				</div>
			)} */}

			{/* Comments Section */}
			<div className='comments-section'>
				<h3>Comments</h3>
				<div className='comment-form'>
					<textarea
						placeholder='Share your thoughts...'
						rows='4'
						value={comment}
						onChange={(e) => setComment(e.target.value)}
					/>
					<button className='btn-primary' onClick={handleCommentSubmit}>
						Post Comment
					</button>
				</div>
			</div>

			{/* Login Modal */}
			{showLoginModal && (
				<div className='fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50'>
					<div className='bg-white rounded-lg shadow-lg p-8 text-center'>
						<p className='mb-6 text-gray-800 text-lg'>
							Please login to post a comment.
						</p>
						<div>
							<button
								className='mr-5 bg-gradient-to-r from-blue-600 to-blue-800 font-normal text-base text-white border border-blue-700 rounded-full shadow px-8 py-2 hover:from-blue-700 hover:to-blue-900 transition'
								onClick={() => setIsAuth(true)}>
								Go to Login
							</button>
							<button
								className='bg-gradient-to-r from-blue-600 to-blue-800 font-normal text-base text-white border border-blue-700 rounded-full shadow px-8 py-2 hover:from-blue-700 hover:to-blue-900 transition'
								onClick={() => setShowLoginModal(false)}>
								Close
							</button>
						</div>
					</div>
				</div>
			)}

			{/* Other Stories */}
			<div className='max-w-4xl mx-auto px-4 py-8'>
				<h2 className='text-3xl font-bold mb-6'>
					Other stories<span className='text-sky-500'>.</span>
				</h2>
				{otherStories.map((item, idx) => (
					<StoryCard
						key={item.slug}
						image={item.imageUrl}
						title={item.title}
						buttonText={idx === 0 ? "Next Story" : "Previous Story"}
						buttonPosition={idx === 0 ? "right" : "left"}
						onClick={() => navigate(`/blog/${item.slug}`)}
					/>
				))}
			</div>
		</div>
	);
}
